import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || 'https://wxhll.huan888.cn/api',
  timeout: 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.token) {
      // let each request carry token
      config.headers['Authorization'] = 'Bearer ' + getToken()
    }

    // 全局区域筛选：注入到普通后台与拓展服务后台 GET 请求，
    // 且不覆盖调用方已显式传入的 province/city
    const url = config.url || ''
    const method = (config.method || 'get').toLowerCase()
    const isRegionalAdminApi = url.indexOf('/admin') === 0 || url.indexOf('/service/admin') === 0
    if (method === 'get' && isRegionalAdminApi) {
      const regionParams = (store.getters && store.getters.regionParams) || {}
      if (regionParams.province || regionParams.city) {
        config.params = config.params || {}
        if (regionParams.province && config.params.province === undefined) {
          config.params.province = regionParams.province
        }
        if (regionParams.city && config.params.city === undefined) {
          config.params.city = regionParams.city
        }
      }
    }

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 防止多个 401 同时弹出多次跳转
let isRedirectingToLogin = false

// response interceptor
service.interceptors.response.use(
  response => {
    // 如果是blob类型的响应（如文件下载），直接返回
    if (response.config.responseType === 'blob') {
      return response.config.preserveBlobResponse ? response : response.data
    }

    const res = response.data

    if (!res.success) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    // 401: 令牌过期/无效 → 直接跳转登录页
    if (error.response && error.response.status === 401) {
      if (!isRedirectingToLogin) {
        isRedirectingToLogin = true
        store.dispatch('user/resetToken').then(() => {
          location.href = '/#/login'
          location.reload()
        })
      }
      return Promise.reject(error)
    }

    let message = error.message
    if (error.response && error.response.data && error.response.data.message) {
      message = error.response.data.message
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
